module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_7.7cdf6bff.png";